import { render, staticRenderFns } from "./CommandRouterSection.vue?vue&type=template&id=371ab6b3&"
import script from "./CommandRouterSection.vue?vue&type=script&lang=ts&"
export * from "./CommandRouterSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports